import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useLocalStorage } from 'react-use';
import { localStorageKeys } from '@sketch/constants';
import { NewFeatureHighlightContainerHeader, NewFeatureHighlightContainerSidebar, StyledLinkButton, CloseIconContainer } from './NewFeatureHighlightPopover.styles.js';
import '../NewFeatureHighlightPopoverBody/index.js';
import '../Box/index.js';
import '../Popover/index.js';
import '../Button/index.js';
import '../NewFeatureHighlight/index.js';
import { ReactComponent } from '@sketch/icons/cross-16';
import { Button } from '../Button/Button.js';
import { Popover } from '../Popover/Popover.js';
import { Box, Flex } from '../Box/BoxSystem.js';
import { NewFeatureHighlight } from '../NewFeatureHighlight/NewFeatureHighlight.js';
import { ButtonUnstyled } from '../Button/ButtonUnstyled.js';
import { NewFeatureHighlightPopoverBody } from '../NewFeatureHighlightPopoverBody/NewFeatureHighlightPopoverBody.js';

const POPOVER_PARAMS = {
    header: {
        placement: 'bottom-start',
        spacing: 0,
        dotWrapper: NewFeatureHighlightContainerHeader,
    },
    sidebar: {
        placement: 'right-start',
        spacing: 0,
        dotWrapper: NewFeatureHighlightContainerSidebar,
    },
};
const NewFeatureHighlightPopover = ({ onConfirm, confirmCopy, highlightPlacement, closeButtonTestId = 'new-feature-hightlight-close', buttonLinkProps, titleText, bodyText, localStorageKey, show = true, children, }) => {
    const [introductionSeen, setIntroductionSeen] = useLocalStorage(localStorageKeys[localStorageKey], false);
    const { placement, spacing, dotWrapper: WrapperComponent } = POPOVER_PARAMS[highlightPlacement];
    const closePopover = () => setIntroductionSeen(true);
    if (introductionSeen || !show) {
        return jsx(Fragment, { children: children });
    }
    const onConfirmClick = () => {
        closePopover();
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
    };
    const getButton = () => {
        if (!buttonLinkProps && !confirmCopy) {
            return undefined;
        }
        if (buttonLinkProps) {
            return (jsx(StyledLinkButton, Object.assign({ variant: "secondary", size: "24", type: "button" }, buttonLinkProps, { children: buttonLinkProps.children })));
        }
        else {
            return (jsx(Button, Object.assign({ variant: "primary", size: "24", onClick: onConfirmClick }, { children: confirmCopy })));
        }
    };
    return (jsx(Popover, Object.assign({ placement: placement, spacing: `${spacing}px`, popup: jsxs(Box, Object.assign({ p: 4, width: 262 }, { children: [jsx(WrapperComponent, { children: jsx(NewFeatureHighlight, {}) }), jsx(CloseIconContainer, { children: jsx(ButtonUnstyled, Object.assign({ onClick: closePopover, "data-testid": closeButtonTestId }, { children: jsx(ReactComponent, { width: "16px" }) })) }), jsx(NewFeatureHighlightPopoverBody, { titleText: titleText, bodyText: bodyText }), getButton() ? (jsx(Flex, Object.assign({ mt: 4, justifyContent: "flex-end" }, { children: getButton() }))) : null] })), visible: !introductionSeen }, { children: children })));
};

export { NewFeatureHighlightPopover };
